const initialState =  [
    { 
        name: {
            "en": "Engineering Department",
            "ko": "엔지니어링 사업부"
        },
        link: "engineering",
        subDepartments : [
            {
                name: {
                    "en": "Construction",
                    "ko": "시공"
                },
                content: {
                    "en": "Image Content Lorem ipsum for some more content to be shown.",
                    "ko": "이미지 내용 설명을 위한 조금 더 긴글. 내용 입력을 해주시면 됩니다."
                },
                storagePath : "construction_images",
                items: null
            },
            {
                name: {
                    "en": "Construction Material",
                    "ko": "자재"
                },
                content: {
                    "en": "Image Content Lorem ipsum for some more content to be shown.",
                    "ko": "이미지 내용 설명을 위한 조금 더 긴글. 내용 입력을 해주시면 됩니다."
                },
                storagePath : "material_images",
                items: null
            }
        ]
    },
    {
        name: {
            en: "Agricultural Products Department",
            ko: "농자재 사업부"
        },
        link: "products",
        subDepartments: [
            {
                name: {
                    en: "Fertilizer",
                    ko: "비료"
                },
                content: {
                    en: "Image Content Lorem ipsum for some more content to be shown.",
                    ko: "이미지 내용 설명을 위한 조금 더 긴글. 내용 입력을 해주시면 됩니다."
                },
                storagePath : "fertilizer_images",
                items: null
            },
            {
                name: {
                    en: "Badge Fertilier",
                    ko: "배지"
                },
                content: {
                    en: "Image Content Lorem ipsum for some more content to be shown.",
                    ko: "이미지 내용 설명을 위한 조금 더 긴글. 내용 입력을 해주시면 됩니다."
                },
                storagePath : "medium_images",
                items: null 
            },
            {
                name: {
                    en: "Others",
                    ko: "기타"
                },
                content: {
                    en: "Image Content Lorem ipsum for some more content to be shown.",
                    ko: "이미지 내용 설명을 위한 조금 더 긴글. 내용 입력을 해주시면 됩니다."
                },
                storagePath : "extra_images",
                items: null
            }
        ]
    },
    {
        items : null
    }
];

const companyReducer = (state = initialState, action) => {
    switch(action.type){
        case 'DEPARTMENTS_LOAD_SUCCESS' : {
            const copy = [...state];
            switch(action.payload.name) {
                case 'constructions' : {
                    copy[0].subDepartments[0].items = [...action.payload.departments];
                }break;
                case 'materials' : {
                    copy[0].subDepartments[1].items = [...action.payload.departments];
                }break;
                case 'fertilizers' : {
                    copy[1].subDepartments[0].items = [...action.payload.departments];
                }break;
                case 'mediums' : {
                    copy[1].subDepartments[1].items = [...action.payload.departments];
                }break;
                case 'extras' : {
                    copy[1].subDepartments[2].items = [...action.payload.departments];
                }break;
                case 'cards' : {
                    copy[2].items = [...action.payload.departments];
                }break;
            }
            return  copy;
        }break;
        default : {
            return state;
        }break;
    }
}

export default companyReducer;


// WEBPACK FOOTER //
// ./src/reducers/companyReducer.js